import {type FC, type ReactNode} from 'react';
import * as React from 'react';
import {BackdropContainer} from './ModalWrapper/ModalWrapper.styled.ts';

export interface BackdropProps {
    isOpen: boolean;
    onClose: () => void;
    animation?: 'fade' | 'slide' | 'scale' | 'none';
    children: ReactNode;
    isTopmost?: boolean;
}

const Backdrop: FC<BackdropProps> = ({isOpen, onClose, animation = 'fade', children, isTopmost = true}) => {
    const handleBackdropClick = (e: React.MouseEvent) => {
        if (e.target === e.currentTarget && onClose && isTopmost) {
            onClose();
        }
    };

    if (!isOpen && (animation === 'none' || !children)) return null;

    return (
        <BackdropContainer $isOpen={isOpen} $animation={animation} onClick={handleBackdropClick}>
            {children}
        </BackdropContainer>
    );
};

export default Backdrop;
